import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/pageLayout/insightsPage.tsx");
